import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { BrandKitState } from './types';

const state: BrandKitState = {
  colors: [],
  fonts: [],
  background: [],
  isLoaded: false,
  fontsFailedToLoad: {}
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
